export default function CardRivista({imageurl,title,frequency,url}){
	return (
	<div className="foryou-alt">
		<div className='prod-cover'>
			<a href={url}>
				<img src={imageurl?imageurl:`${process.env.PUBLIC_URL}/placeholder.png`} alt={title} />
				<div>
					<h6>{title}</h6>
				</div>
				<p>{frequency}</p>
			</a>
		</div>
	</div>
	);
};
